import { graphql } from '../../schemas/server_admin_query'

export const query_audit_logs = graphql(`
  query query_audit_logs(
    $limit: Int
    $severity: String
    $start_date: ISO8601DateTime
    $end_date: ISO8601DateTime
    $user_id: String
  ) {
    audit_logs(
      limit: $limit
      severity: $severity
      start_date: $start_date
      end_date: $end_date
      user_id: $user_id
    ) {
      id
      action
      description
      severity
      ip_address
      user_id
      tags
      references
      created_at
      updated_at
      user {
        id
        email
        name
        image
        roles
        uuid
      }
    }
  }
`)
